import { render } from "./MenuVersion.vue?vue&type=template&id=61b1ef90&scoped=true&ts=true"
import script from "./MenuVersion.vue?vue&type=script&lang=ts"
export * from "./MenuVersion.vue?vue&type=script&lang=ts"

import "./MenuVersion.vue?vue&type=style&index=0&id=61b1ef90&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/platform/platform/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b1ef90"]])

export default __exports__